import { api } from '../../lib/apiClient';

export type FeedRun = {
  id: string;
  agent_id: string;
  agent_name: string;
  agent_template: string;
  triggered_by: string;
  objective: string;
  summary?: string;
  outcome?: string;
  status: 'pending' | 'running' | 'done' | 'failed';
  created_at: string;
  started_at?: string;
  finished_at?: string;
  tokens_input: number;
  tokens_output: number;
};

export type FeedTx = {
  id: string;
  agent_id: string;
  agent_name: string;
  agent_template: string;
  run_id?: string;
  chain: string;
  tx_hash: string;
  from_address: string;
  asset: string;
  value_wei: string;
  token_symbol?: string;
  token_amount?: string;
  recipient: string;
  reason?: string;
  status: 'broadcast' | 'confirmed' | 'reverted' | 'timeout' | 'failed';
  broadcast_at: string;
  confirmed_at?: string;
};

export type ActivityFeed = {
  active_runs: number;
  latest_runs: FeedRun[];
  latest_tx: FeedTx[];
  generated_at: string;
};

export async function getOrgActivity(orgId: string, limit = 30): Promise<ActivityFeed> {
  const res = await api.get<{ data: ActivityFeed }>(
    `/v1/orgs/${orgId}/activity?limit=${limit}`,
  );
  return res.data.data;
}
